import { get, put, del, post } from '@/services/http';

export class ReplenishmentSettingHistory {
  public key: string = 'replenishment_setting_history';
  public values: any = [];

  constructor(data: any = {}) {

  }

  public async fetch() {
    const res: any = await get(`/users/config`, {key: this.key});
    if (res.data && res.data[0] && res.data[0].options) {
      this.values = res.data[0].options;
    }
  }

  public async save(values: any) {
    const res: any = await post(`/users/config`, {
      key: this.key,
      values: '',
      options: values,
    });
  }

  public async isLastSettingCompleted(): Promise<boolean> {
    try {
      const res: any = await get('/replenishment_settings/records', { limit: 1 });
      if (res.data && res.data.length > 0) {
        return res.data[0].status === 'COMPLETED';
      }
    } catch (error) {
      console.error('Error checking replenishment setting status:', error);
    }
    return false;
  }

  public async getLastSettingStatus(): Promise<string> {
    try {
      const res: any = await get('/replenishment_settings/records', { limit: 1 });
      if (res.data && res.data.length > 0) {
        return res.data[0].status;
      }
    } catch (error) {
      console.error('Error checking replenishment setting status:', error);
    }
    return '';
  }

}
